import { App } from 'vue'
// import registerElement from './register-element'
import { setupPermissionDirective } from './permission-directive'

export function globalRegister(app: App): void {
  //registerElement(app)
  setupPermissionDirective(app)
}
